import { render, staticRenderFns } from "./AddMergeFields.vue?vue&type=template&id=52d1ac72&scoped=true&"
import script from "./AddMergeFields.vue?vue&type=script&lang=js&"
export * from "./AddMergeFields.vue?vue&type=script&lang=js&"
import style0 from "./AddMergeFields.vue?vue&type=style&index=0&id=52d1ac72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1ac72",
  null
  
)

export default component.exports